module.exports = __webpack_public_path__ + "static/media/team-member-card.641e04ab.jpg";